"use strict";

var _defineProperty = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _regeneratorRuntime = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchUserOwnedNFTs = exports.fetchZoraIndexerItem = exports.getIndexerServerTokenInfo = exports.fetchZoraIndexerList = exports.fetchZNFTGroupData = exports.fetchNFTData = exports.prepareJson = void 0;

var address_1 = require("@ethersproject/address");

var addresses_1 = require("../constants/addresses");

var OpenseaUtils_1 = require("./OpenseaUtils");

var TransformFetchResults_1 = require("./TransformFetchResults");
/**
 * This removes undefined values to sanitize
 * data objects to work with nextJS server-side
 * page props.
 *
 * @param json Object to sanitize for JSON fields
 * @returns JSON-safe object
 */


function prepareJson(json) {
  return JSON.parse(JSON.stringify(json));
}

exports.prepareJson = prepareJson;
/**
 * Async function to fetch auction information and metadata for any
 * NFT or zNFT. Mirrors behavior of useNFT hook but for server-side rendering.
 * Fetches all metadata and auction information server-side. Will be re-validated client-side.
 * Can pass return value directly into `initialData` for useNFT hook.
 *
 * @param tokenId: Token ID to fetch
 * @param contractAddress: Contract address to fetch token from
 * @param fetchAgent: MediaFetchAgent instance
 * @param prepareDataJSON: Sanitizes undefined fields to allow data to work with next.js
 * @returns object with nft and metadata fields, any issues throw an RequestError
 */

var fetchNFTData = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var tokenId, contractAddress, fetchAgent, _ref$prepareDataJSON, prepareDataJSON, auctionData, nft, metadata, response, _nft, _metadata, _response;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            tokenId = _ref.tokenId, contractAddress = _ref.contractAddress, fetchAgent = _ref.fetchAgent, _ref$prepareDataJSON = _ref.prepareDataJSON, prepareDataJSON = _ref$prepareDataJSON === void 0 ? true : _ref$prepareDataJSON;

            if (!(contractAddress && contractAddress !== addresses_1.ZORA_MEDIA_CONTRACT_BY_NETWORK[fetchAgent.networkId])) {
              _context.next = 15;
              break;
            }

            _context.next = 4;
            return fetchAgent.loadAuctionInfo(contractAddress, tokenId);

          case 4:
            auctionData = _context.sent;
            _context.next = 7;
            return fetchAgent.loadNFTData(contractAddress, tokenId, auctionData);

          case 7:
            nft = _context.sent;
            metadata = OpenseaUtils_1.openseaDataToMetadata(nft);
            response = {
              nft: nft,
              metadata: metadata
            };

            if (!prepareDataJSON) {
              _context.next = 12;
              break;
            }

            return _context.abrupt("return", prepareJson(response));

          case 12:
            return _context.abrupt("return", response);

          case 15:
            _context.next = 17;
            return fetchAgent.loadZNFTData(tokenId);

          case 17:
            _nft = _context.sent;
            _context.next = 20;
            return fetchAgent.fetchIPFSMetadata(_nft.nft.metadataURI);

          case 20:
            _metadata = _context.sent;
            _response = {
              nft: _nft,
              metadata: _metadata
            };

            if (!prepareDataJSON) {
              _context.next = 24;
              break;
            }

            return _context.abrupt("return", prepareJson(_response));

          case 24:
            return _context.abrupt("return", _response);

          case 25:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchNFTData(_x) {
    return _ref2.apply(this, arguments);
  };
}();

exports.fetchNFTData = fetchNFTData;
/**
 * Server-side initial data hook for zNFTGroup data hook
 *
 * @param ids list of ids (addresses for creator or owner, znft id for NFT)
 * @param type type of 'id' or 'creator' or 'owner' to determine what type of data to fetch
 * @returns NFTDataType
 */

var fetchZNFTGroupData = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3) {
    var ids, type, fetchAgent, _ref3$prepareDataJSON, prepareDataJSON, nftGroup, response;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            ids = _ref3.ids, type = _ref3.type, fetchAgent = _ref3.fetchAgent, _ref3$prepareDataJSON = _ref3.prepareDataJSON, prepareDataJSON = _ref3$prepareDataJSON === void 0 ? true : _ref3$prepareDataJSON;
            _context2.next = 3;
            return fetchAgent.fetchZNFTGroupData(ids, type);

          case 3:
            nftGroup = _context2.sent;
            response = nftGroup.map(function (media) {
              return _objectSpread(_objectSpread({}, media), {}, {
                pricing: TransformFetchResults_1.addAuctionInformation(media.pricing)
              });
            });

            if (!prepareDataJSON) {
              _context2.next = 7;
              break;
            }

            return _context2.abrupt("return", prepareJson(response));

          case 7:
            return _context2.abrupt("return", response);

          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function fetchZNFTGroupData(_x2) {
    return _ref4.apply(this, arguments);
  };
}();

exports.fetchZNFTGroupData = fetchZNFTGroupData;

var transformServerSideIndexerDataList = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(fetchAgent, response) {
    var auctionInfos;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return fetchAgent.loadAuctionInfos(response.map(function (element) {
              return "".concat(element.address.toLowerCase(), "-").concat(element.tokenId);
            }));

          case 2:
            auctionInfos = _context3.sent;
            return _context3.abrupt("return", response.map(function (tokenData) {
              return {
                nft: {
                  tokenData: tokenData,
                  auctionData: auctionInfos.map(function (auction) {
                    return auction instanceof Error ? undefined : auction;
                  }).find(function (auction) {
                    return (auction === null || auction === void 0 ? void 0 : auction.tokenContract.toLowerCase()) === tokenData.address.toLowerCase() && (auction === null || auction === void 0 ? void 0 : auction.tokenId) === tokenData.tokenId.toString();
                  })
                }
              };
            }));

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function transformServerSideIndexerDataList(_x3, _x4) {
    return _ref5.apply(this, arguments);
  };
}();
/**
 * Server-side initial data hook for zora nft indexer response data
 *
 * @param fetchAgent FetchAgent class
 * @param listOptions Options of what objects to list (limited to contract address at the moment)
 *    has limit and offset fields
 * @param prepareDataJson prepare data for vercel static prop passing by cleaning up invalid JSON objects
 */


var fetchZoraIndexerList = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(fetchAgent, listOptions) {
    var prepareDataJson,
        response,
        result,
        _args4 = arguments;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            prepareDataJson = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : true;
            _context4.next = 3;
            return fetchAgent.fetchZoraIndexerGroupData(listOptions);

          case 3:
            response = _context4.sent;
            _context4.next = 6;
            return transformServerSideIndexerDataList(fetchAgent, response);

          case 6:
            result = _context4.sent;

            if (!prepareDataJson) {
              _context4.next = 9;
              break;
            }

            return _context4.abrupt("return", prepareJson(result));

          case 9:
            return _context4.abrupt("return", result);

          case 10:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function fetchZoraIndexerList(_x5, _x6) {
    return _ref6.apply(this, arguments);
  };
}();

exports.fetchZoraIndexerList = fetchZoraIndexerList;

var getIndexerServerTokenInfo = function getIndexerServerTokenInfo(_ref7) {
  var tokenData = _ref7.nft.tokenData;

  var _a, _b, _c;

  return {
    tokenId: tokenData.tokenId.toString(),
    tokenContract: tokenData.address,
    metadata: (_a = tokenData.metadata) === null || _a === void 0 ? void 0 : _a.json,
    image: ((_c = (_b = tokenData.metadata) === null || _b === void 0 ? void 0 : _b.json) === null || _c === void 0 ? void 0 : _c.image_url) ? tokenData.metadata.json.image_url : tokenData.media ? tokenData.media.contentURI : null
  };
};

exports.getIndexerServerTokenInfo = getIndexerServerTokenInfo;
/**
 * Server-side initial data hook for zora nft indexer response data
 *
 * @param fetchAgent FetchAgent class
 * @param listOptions Options of what objects to list (limited to contract address at the moment)
 *    has limit and offset fields
 * @param prepareDataJson prepare data for vercel static prop passing by cleaning up invalid JSON objects
 */

var fetchZoraIndexerItem = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(fetchAgent, listOptions) {
    var prepareDataJson,
        response,
        result,
        _args5 = arguments;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            prepareDataJson = _args5.length > 2 && _args5[2] !== undefined ? _args5[2] : true;
            _context5.next = 3;
            return fetchAgent.fetchZoraNFTIndexerNFTs(["".concat(address_1.getAddress(listOptions.collectionAddress), "-").concat(listOptions.tokenId)]);

          case 3:
            response = _context5.sent;
            _context5.next = 6;
            return transformServerSideIndexerDataList(fetchAgent, response);

          case 6:
            result = _context5.sent;

            if (!prepareDataJson) {
              _context5.next = 9;
              break;
            }

            return _context5.abrupt("return", prepareJson(result[0]));

          case 9:
            return _context5.abrupt("return", result[0]);

          case 10:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function fetchZoraIndexerItem(_x7, _x8) {
    return _ref8.apply(this, arguments);
  };
}();

exports.fetchZoraIndexerItem = fetchZoraIndexerItem;
/**
 * Server-side initial data hook for zora nft indexer response data
 *
 * @param fetchAgent FetchAgent class
 * @param listOptions Options of what objects to list (limited to contract address at the moment)
 *    has limit and offset fields
 * @param prepareDataJson prepare data for vercel static prop passing by cleaning up invalid JSON objects
 */

var fetchUserOwnedNFTs = /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(fetchAgent, _ref9) {
    var collectionAddresses,
        userAddress,
        offset,
        limit,
        prepareDataJson,
        response,
        result,
        _args6 = arguments;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            collectionAddresses = _ref9.collectionAddresses, userAddress = _ref9.userAddress, offset = _ref9.offset, limit = _ref9.limit;
            prepareDataJson = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : false;
            _context6.next = 4;
            return fetchAgent.fetchZoraIndexerUserOwnedNFTs({
              collectionAddresses: collectionAddresses,
              userAddress: userAddress,
              limit: limit,
              offset: offset
            });

          case 4:
            response = _context6.sent;
            _context6.next = 7;
            return transformServerSideIndexerDataList(fetchAgent, response);

          case 7:
            result = _context6.sent;

            if (!prepareDataJson) {
              _context6.next = 10;
              break;
            }

            return _context6.abrupt("return", prepareJson(result));

          case 10:
            return _context6.abrupt("return", result);

          case 11:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function fetchUserOwnedNFTs(_x9, _x10) {
    return _ref10.apply(this, arguments);
  };
}();

exports.fetchUserOwnedNFTs = fetchUserOwnedNFTs;